/**
 * ユーザー情報ユーティリティ
 * localStorageからユーザー情報を取得（ログイン時に保存済み）
 */

export interface UserInfo {
  user_id: string;
  user_name?: string;
  role: string;
  permitted_dept_list?: string[];
}

/**
 * localStorageからユーザー情報を取得
 * @returns ユーザー情報、存在しない場合はnull
 */
export const getUserInfo = (): UserInfo | null => {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    if (!userInfoStr) {
      return null;
    }
    return JSON.parse(userInfoStr) as UserInfo;
  } catch (error) {
    console.error('Failed to get user info from localStorage:', error);
    return null;
  }
};

/**
 * ユーザーの役割を取得
 * @returns ユーザーの役割、存在しない場合は'user'
 */
export const getUserRole = (): string => {
  const userInfo = getUserInfo();
  return userInfo?.role || 'user';
};

/**
 * ユーザーの許可署リストを取得
 * @returns ユーザーの許可署リスト、存在しない場合は空配列
 */
export const getPermittedDepts = (): string[] => {
  const userInfo = getUserInfo();
  return userInfo?.permitted_dept_list || [];
};

